import Counter from "@/components/booking/Counter";
import { fmt, tl } from "@/lib/booking";
import { t } from "@/lib/i18n";

export default function CountsStep({ v, set, cfg, error }) {
  const total = v.adult + v.child + v.free;
  const canInc = total < cfg.max_persons;
  const age = (a) => (a ? fmt(t("bilet.counts.ages"), { min: a[0], max: a[1] }) : null);
  const price = (p) => (p == null ? null : `${tl(p)} ${t("bilet.counts.perPerson")}`);
  const rows = [
    ["adult", t("bilet.counts.adult"), price(cfg.prices.adult), 1],
    ["child", t("bilet.counts.child"), [age(cfg.ages.child), price(cfg.prices.child)].filter(Boolean).join(" · "), 0],
    ["free", t("bilet.counts.free"), [age(cfg.ages.free), t("bilet.counts.freeLabel")].filter(Boolean).join(" · "), 0],
  ];
  return (
    <div className="max-w-xl" data-testid="booking-counts-step">
      <div className="rounded-2xl border border-line bg-white px-5 divide-y divide-line">
        {rows.map(([k, label, sub, min]) => (
          <Counter key={k} id={`booking-${k}`} label={label} sub={sub} value={v[k]} min={min} canInc={canInc} onChange={(n) => set({ [k]: n })} />
        ))}
      </div>
      <p className="mt-3 text-sm text-ink-muted" data-testid="booking-counts-total">
        {fmt(t("bilet.counts.total"), { n: total })} · {fmt(t("bilet.counts.max"), { n: cfg.max_persons })}
      </p>
      {error && <p role="alert" className="mt-2 text-sm text-[#B42318]" data-testid="booking-counts-error">{error}</p>}
    </div>
  );
}
